import { render, staticRenderFns } from "./imbalance_colors.vue?vue&type=template&id=7480c190&scoped=true&"
import script from "./imbalance_colors.vue?vue&type=script&lang=ts&"
export * from "./imbalance_colors.vue?vue&type=script&lang=ts&"
import style0 from "./imbalance_colors.vue?vue&type=style&index=0&id=7480c190&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7480c190",
  null
  
)

export default component.exports